import { c as _c } from "react/compiler-runtime";
import { fontSizes } from '@newfront-insurance/core-ui';
import * as React from 'react';
import type { JSX } from 'react';
import type { AppType } from '../../../../metadata/apps';
import { getAppTypeMetadata } from '../../../../metadata/apps';
interface Props {
  type: AppType;
  iconSize?: 32 | 40;
  textSize?: 'small' | 'large';
  showDescription?: boolean;
  isShowingDarkSidebar?: boolean;
}
export function AppBadge(props) {
  const $ = _c(22);
  const {
    type,
    iconSize: t0,
    textSize: t1,
    showDescription: t2,
    isShowingDarkSidebar
  } = props;
  const iconSize = t0 === undefined ? 32 : t0;
  const textSize = t1 === undefined ? "small" : t1;
  const showDescription = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== type) {
    t3 = getAppTypeMetadata(type);
    $[0] = type;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    label,
    icon: Icon,
    description
  } = t3;
  const textSizeValue = textSize === "small" ? fontSizes.regular.fontSize : fontSizes.large.fontSize;
  const t4 = `flex flex-row items-center ${iconSize === 40 ? "gap-5" : "gap-2"}`;
  let t5;
  if ($[2] !== Icon || $[3] !== iconSize) {
    t5 = <Icon size={iconSize} />;
    $[2] = Icon;
    $[3] = iconSize;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = `flex flex-col ${!showDescription ? "gap-1" : "gap-0"}`;
  const t7 = isShowingDarkSidebar ? "#fff" : "#db0e63";
  let t8;
  if ($[5] !== t7 || $[6] !== textSizeValue) {
    t8 = {
      "--fontSize": textSizeValue,
      color: t7
    };
    $[5] = t7;
    $[6] = textSizeValue;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = t8 as React.CSSProperties;
  let t10;
  if ($[8] !== label || $[9] !== t9) {
    t10 = <span className="block leading-4 font-semibold" style={t9}>{label}</span>;
    $[8] = label;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== description || $[12] !== showDescription) {
    t11 = showDescription ? <span className="text-steel-400 text-sm leading-3">{description}</span> : null;
    $[11] = description;
    $[12] = showDescription;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t6) {
    t12 = <div className={t6}>{t10}{t11}</div>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t6;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t4 || $[20] !== t5) {
    t13 = <div className={t4}>{t5}{t12}</div>;
    $[18] = t12;
    $[19] = t4;
    $[20] = t5;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}